export default __webpack_public_path__ + "static/media/Snd_FirstWatchMe.2d9b0ca4.mp3";